import React from 'react'
import { Typography, Card, CardContent, Grid, Avatar, Icon  } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { PropTypes } from 'prop-types'

import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';

const useStyles = makeStyles((theme) => ({
    root: {
        // paddingBottom: 16
        marginBottom: -8
    },
    avatar:{
        width: 56,
        height: 56,
        background: props=> props.avatarColor, //theme.palette.primary.main
    },
    bottomSection:{
        display: 'flex',
        '& *':{
            marginRight: 4
        }
    }

}));

function CardComp(props) {
    const { className, title , value, percentage, since, iconMain, avatarColor, ...rest } = props
    const classes = useStyles(props);
    return (
        
        <div>
            <Card 
            {...rest}
            >
                <CardContent className={classes.root}>

                <Grid container spacing={1}>
                    <Grid item xs={8}>
                        <Typography  gutterBottom variant="h5" color="textSecondary" >
                           {title}
                        </Typography>
                        <Typography  color="primary" gutterBottom variant="h2">
                            {value}
                        </Typography>
                    </Grid>
                    <Grid item xs={4} align="right" >
                    <Avatar className={classes.avatar}>
                      {iconMain}
                    </Avatar>
                    </Grid>
                    <Grid item xs={12} className={classes.bottomSection}>
                        <ArrowUpwardIcon  className={classes.subIcon} />
                        <Typography variant="h5">
                            {percentage}
                        </Typography>
                        <Typography  variant="h6" color="textSecondary">
                           {since}
                        </Typography>
                    </Grid>
                </Grid>
                </CardContent>
                
            </Card>
        </div>
    )
}

export default CardComp
CardComp.propTypes={
    className: PropTypes.string,
    title: PropTypes.string.isRequired,
    value : PropTypes.string.isRequired,
    percentage : PropTypes.string.isRequired,
    since: PropTypes.string.isRequired,
    iconMain: PropTypes.node.isRequired,
    avatarColor: PropTypes.any.isRequired
}
